<template>
    <div class="intro">

        <!-- <div class="intro__caption__holder" data-gsap="fromStartEnd" data-gsap-start="top 95%" data-gsap-end="bottom center"> -->
        <div class="intro__caption__holder" 
            :data-gsap="isAnimated ? 'fadeIn' : null" 
            :data-gsap-delay="isAnimated ? '0.3' : null" 
            :data-gsap-initial-scale="isAnimated ? '1' : null">
            <!-- <div class="intro__index" v-if="index">0{{index}}</div> -->
            <div class="intro__caption" v-html="intro.Caption "></div>
        </div>

        <div :class="{ intro__two__columns : twoColumns }">

            <h1 ref="animate" 
                :class="['', { 'animated-heading': isAnimated }]" 
                data-gsap-type="chars" 
                data-gsap-duration="0.3" 
                data-gsap-stagger="0.04"
                data-gsap-distance="50"
                data-gsap-initial-scale="0.7"
                v-html="intro.Title" 
                v-if="isCover">
            </h1>
            <!-- <h1 v-html="intro.Title" v-if="isCover"></h1> -->
            <h2 ref="animate" 
                :class="['', { 'animated-heading': isAnimated }]" 
                data-gsap-type="chars" 
                data-gsap-duration="0.3" 
                data-gsap-stagger="0.04"
                data-gsap-distance="10"
                v-html="intro.Title" 
                v-else >
            </h2>
            <!-- <h2 v-html="intro.Title" v-else ></h2> -->

            
            <!-- <h3 v-if="isContactPage" v-html="subtitle"></h3> -->

            <!-- <p v-html="intro.Description"></p> -->
            <p  v-html="intro.Description" 
                :class="['', { 'animated-heading': isAnimated }]" 
                data-gsap-type="lines" 
                data-gsap-start="top 80%" 
                data-gsap-end="bottom center" 
                data-gsap-delay="0.42"
                data-gsap-distance="50"
                >
            </p>

        </div>

        <!-- <a class="general-button" v-if="label && href && isExternal" :href="href" :target="isExternal ? '_blank' : '' " data-gsap="fromStartEnd" data-gsap-start="top 80%" data-gsap-end="bottom center" data-gsap-delay="0.45"> -->
        <a class="general-button" :class="buttonClass" v-if="label && href && isExternal" :href="href" :target="isExternal ? '_blank' : '' ">
            {{ label }}
            <div class="general-button__icon">
                <arrow-right/>
            </div>
        </a>
        <!-- <router-link v-else-if="label && href && !isExternal" class="general-button" :to="href" data-gsap="fromStartEnd" data-gsap-start="top 80%" data-gsap-end="bottom center" data-gsap-delay="0.45"> -->
        <router-link v-else-if="label && href && !isExternal" class="general-button" :class="buttonClass" :to="href">
            {{ label }}
            <div class="general-button__icon">
                <arrow-right/>
            </div>
        </router-link>
    </div>
</template>


<script lang="ts">
import { defineComponent, PropType } from 'vue'



import ArrowRight from "./svg/ArrowRight.vue"


export default defineComponent({
    components: {
        ArrowRight
    },
    props: {
        intro: {
            type: Object as PropType<{ Caption: string; Title: string; Description: string; }>,
            required: true
        },
        button: {
            type: Object as PropType<{ href: string; label: string; isExternal: boolean; }>,
            required: false
        },
        subtitle: {
            type: String,
            required: false
        },
        index: {
            type: Number,
            required: false,
        },
        isCover:{
            type: Boolean,
            default: false,
            required: false,
        },
        twoColumns:{
            type: Boolean,
            default: false,
            required: false,
        },
        isContactPage:{
            type: Boolean,
            default: false,
            required: false
        },
        buttonClass:{
            type: String,
            default: '',
            required: false
        },
        isAnimated:{
            type: Boolean,
            default: false,
            required: false
        }
    },
    setup(props) {
        const { intro, button } = props;
        const { href, label, isExternal } = button || {};
        const { buttonClass } = props;
        const { isAnimated } = props;




        return { intro, href, label, isExternal, buttonClass, isAnimated }
    }

})
</script>
